/**
 * 认证详情成绩导入
 */
import React from "react";
import { connect } from 'dva';
import { framework_tool, component_tool,utils_tool } from '@/tool'
import 'antd/dist/antd.css';
import { modelUtils } from '@/utils';
let {Session} = utils_tool
let { WizContainer } = framework_tool;
import { ExportExcel } from '@/components/index'
import { width } from "dom7";
import { WizTableForm } from '@/containers/common'
const classAideRemoteAuth = WizTableForm.Config.classAideRemoteAuth(this, { apiParams: { aideTypeId: 8 } })

let { WizSpin, WizTypography, WizModal, WizSelect } = component_tool;
const { Paragraph } = WizTypography;

class StudentRemoteAuthScoreImport extends WizContainer {

  componentName = 'studentRemoteAuthScoreImport';

  constructor(props) {
    super(props);
    const {history} = props
    let classAideInfo = undefined;
    if (history.location && history.location.pathname === '/face/classList/classAideDetail/classStudentRemoteAuthList/studentRemoteAuthScoreImport') {
      if (history.location && history.location.record) {
        classAideInfo = history.location.record
        Session.set('classAideInfo', classAideInfo)
      } else {
        classAideInfo = Session.get('classAideInfo') || {}
      }
    }
    this.classAideInfo = classAideInfo;
    this.state = {
      aide: classAideInfo && classAideInfo.classAideId ? classAideInfo.classAideId : null,
      aideName : classAideInfo && classAideInfo.aideName ? classAideInfo.aideName : null,
    }
  }

  propsAndStateOnChange = {
    importScoreRe: this._handldImport.bind(this),
  };

  /**
   * 保存后返回提示
   * @param nextProps
   * @param nextState
   * @private
   */
  _handldImport(nextProps, nextState) {
    let o = nextProps['importScoreRe']
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g,"\n")
      wizNotice.success({
        key:'default',
        message:'成功',
        description: (
          <div>
            <p style={{whiteSpace: "pre-line"}}>{str}</p>
          </div>
        ),
      })
      return true;
    } else {
      wizNotice.error("导入数据出错，请联系相关人员")
      return false;
    }
  }

  /**改变state值 */
  changeScope(key,value,record){
    this.setState({
      [key]:value
    })
  }

  /** 导入成绩 接口待开发*/  
  importScore(other = {}) {
    this.doAction({
      path: 'studentRemoteAuthDetail/importScoreRe',
      payload: {
        key: 'studentRemoteAuthDetail@importScoreRe',
        apiParams: {...other}
      },
      autoInit: true,
    })
  }


  _render() {
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3. 当完成Excel文件的填写后，点击“上传文件”按钮上传此文件，并点击“导入”系统会校验数据的正确性，并提示错误的数据；在校验无错误的情况下，将数据导入到系统中。</Paragraph>,
      ]
    }

    let operateProps = {
      title: '认证详情成绩导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        href: constants.files.excel_remoteAuthScoreFileImport,
      }
    }

    let submit = (file, fileData) => {
      if(!this.state.aide){
        wizNotice.info('请选择认证环节！');
        return;
      }
      this.importScore({
        fileData:fileData,
        aideId:this.state.aide,
        dataType:1 // 独立的远程认证详情列表数据,需传1 即仅允许导入已分配讲师的学员成绩
      })
    }
    let { studentRemoteAuthDetailLoading } = this.props;
    let other = [
      {
        item: { label: '环节名称', required: true },
        comp: (callback) => {
          return (
            <WizTableForm  style={{width:200}}
            placeholder="请选择环节"
            onChange={this.changeScope.bind(this,'aide')}
            selectType = 'radio'
            {...classAideRemoteAuth} 
            rowTitle={"name"} 
            initRows={this.classAideInfo ? [{ id: this.state.aide, aideName: this.state.aideName }] : []}
            value={this.classAideInfo && this.state.aide  ? this.state.aide  : null}
            disabled = {this.classAideInfo ? true : false}
            />
          )
        }
      },
    ]

    return (
      <WizSpin tip={'文件上传中'} spinning={studentRemoteAuthDetailLoading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          submit={submit}
          other={other}
        />
      </WizSpin>
    );
  }
}


const mapStateToProps = (state, ownProps) => {
  const { studentRemoteAuthDetail } = state;
  const importScoreRe = modelUtils.getModelEntity(studentRemoteAuthDetail, "studentRemoteAuthDetail@importScoreRe");
  const load = modelUtils.getLoadingState(state, 'studentRemoteAuthDetail')
  return {
    importScoreRe,
    ...load
  }
};

export default connect(mapStateToProps)(StudentRemoteAuthScoreImport);
